import {Component, Input, OnInit} from '@angular/core';
import {SeriesDataTableFormService} from "./series-data-table-form.service";
import {CdkDrag, CdkDragDrop, CdkDropList, moveItemInArray} from "@angular/cdk/drag-drop";
import {ConfigStub} from "../../_typing/config-stub";
import {Process} from "../../_models/process";
import {Series} from '../../_models/series';
import {MatCheckboxChange} from "@angular/material/checkbox";
import {ModelID} from "../../_typing/generic-types";
import {concatMap, take, tap} from "rxjs/operators";
import {SeriesDataTableConfig} from "../../_typing/config/series-data-table";
import {SeriesDataTableService} from "../../tables/series-data-table/series-data-table.service";
import {COMMON_FORM_IMPORTS} from "../../shared/import-groups/Common";
import {SelectManySearchBaseComponent} from "../../components/select-search-api/many/select-many-search-base.component";
import {SharedPipesModule} from "../../shared/modules/shared-pipes.module";
import {MatMenu, MatMenuTrigger} from "@angular/material/menu";
import {TableColumnMenuComponent} from "../table-column-menu/table-column-menu.component";
import {
    SeriesSummaryColumnSelectorComponent
} from "../../components/series-summary-column-selector/series-summary-column-selector.component";
import {CommonModule} from "@angular/common";
import {CapitalisePipe} from "../../shared/pipes";

@Component({
    selector: 'series-data-table-form',
    templateUrl: './series-data-table-form.component.html',
    styleUrls: ['./series-data-table-form.component.less'],
    imports: [
        COMMON_FORM_IMPORTS,
        SelectManySearchBaseComponent,
        SharedPipesModule,
        CommonModule,
        CdkDropList,
        CdkDrag,
        MatMenuTrigger,
        MatMenu,
        TableColumnMenuComponent,
        SeriesSummaryColumnSelectorComponent,
        CapitalisePipe
    ],
    providers: [SeriesDataTableFormService, SeriesDataTableService]
})
export class SeriesDataTableFormComponent implements OnInit {
    @Input() config: SeriesDataTableConfig;
    process_filters: { [key: string]: any[] } = {};
    colMenuOptions: string[];
    col_menu_options: string[] = ['bold', 'italic', 'size', 'fit_content', 'colour', 'background_colour', 'decimals', 'align'];
    sortOptions = ['custom', 'report', 'name', 'description', 'alias'];
    processListFilters: any[];

    constructor(private cps: SeriesDataTableFormService,
                private seriesDataTableService: SeriesDataTableService
    ) {
    }

    ngOnInit(): void {
        this.colMenuOptions = this.seriesDataTableService.seriesDataTableMenuOptions;
        this.config = this.cps.setDefaults(this.config);
        if (this.config.process_list) {
            this.processSelected(this.config.process_list);
        }
        this.processListFilters = this.cps.processesWithSeriesFilter();
    }

    processSelected($event) {
        this.config.process_list = ConfigStub.getConfigStubs<Process>($event);
        this.process_filters = this.cps.getSeriesLightFilters($event);
        this.cps.getSeriesForProcesses(this.config).pipe(take(1), tap(result => {
            this.config.process_series_map = result;
        })).subscribe();
    }

    seriesSelected($event, processId: ModelID) {
        let seriesGroupDict = {};
        if ($event?.length < this.config.process_series_map?.[processId]?.length) {
            this.config.process_sort_map[processId].all_series = false;
        }
        this.config.process_series_map[processId].forEach(s => seriesGroupDict[s.id] = s.group || '');
        this.config.process_series_map[processId] = $event?.map((s: Series) => {
            const group = {group: seriesGroupDict[s.id] || ''}
            return Object.assign(new ConfigStub<Series>(s), group);
        });
    }

    updateSort($event, processId: ModelID): void {
        this.cps.seriesSelectionSort(processId, this.config).pipe(take(1)).subscribe();
    }

    seriesSelectionSort(processId: ModelID) {
        this.cps.seriesSelectionSort(processId, this.config).pipe(take(1)).subscribe();
    }

    updateGroups(event: MatCheckboxChange, type) {
        if (!event.checked) return;
        if (type === 'custom') {
            this.config.header_rows.process = false;
        } else {
            this.config.header_rows.custom_groups = false;
        }
    }

    drop(event: CdkDragDrop<string[]>, processId: ModelID) {
        moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
        this.config.process_sort_map[processId].sort = 'custom';
    }

    toggleAllSeries($event, processId: ModelID) {
        if ($event === true) {
            this.cps.getMissingSeriesForProcess(processId, this.config).pipe(
                concatMap(() => this.cps.seriesSelectionSort(processId, this.config)),
                take(1)
            ).subscribe(result => {
                this.config.process_series_map[processId] = result
            })
        }
    }

}
